import { View, Text, Animated, Platform, StatusBar } from "react-native";
import React from "react";
import { height, width } from "./imports";
import { primary } from "./colors";
import A from "./assets/svg/A";
import S from "./assets/svg/S";
import Q from "./assets/svg/Q";
import ASQPEN from "./assets/svg/ASQ-PEN";
import { useRef } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
export default function Splash({ setSplashDone }) {
  const main = useSelector((store) => store.main);
  const AAnimation = useRef(new Animated.Value(-height - 200)).current;
  const SAnimation = useRef(new Animated.Value(-height - 200)).current;
  const QAnimation = useRef(new Animated.Value(-height - 200)).current;
  const ASQPENAnimation = useRef(new Animated.Value(-height - 200)).current;
  useEffect(() => {
    Animated.sequence([
      Animated.spring(AAnimation, {
        toValue: 0,
        useNativeDriver: false,
        duration: 1000,
      }),
      Animated.spring(SAnimation, {
        toValue: 0,
        useNativeDriver: false,
        duration: 1000,
      }),
      Animated.spring(QAnimation, {
        toValue: 0,
        useNativeDriver: false,
        duration: 1000,
      }),
      Animated.spring(ASQPENAnimation, {
        toValue: 0,
        useNativeDriver: false,
        duration: 1000,
      }),
    ]).start(() => {
      setSplashDone(true);
    });
  }, []);
  // Animated.sequence([
  //   Animated.spring(AAnimation, {
  //     toValue: 0,
  //     useNativeDriver: false,
  //     duration: 1000,
  //   }),
  //   Animated.spring(SAnimation, {
  //     toValue: 0,
  //     useNativeDriver: false,
  //     duration: 1000,
  //   }),
  //   Animated.spring(QAnimation, {
  //     toValue: 0,
  //     useNativeDriver: false,
  //     duration: 1000,
  //   }),
  //   Animated.spring(ASQPENAnimation, {
  //     toValue: 0,
  //     useNativeDriver: false,
  //     duration: 1000,
  //   }),
  // ]).start();

  return (
    <View
      style={{
        top: 0,
        bottom: 0,
        direction: "ltr",
        position: "absolute",
        height:
          Platform.OS === "android" ? height + StatusBar.currentHeight : height,
        width: width,
        backgroundColor: primary,
        display: "flex",
        flexDirection:
          Platform.OS === "android" && main.rtl ? "row-reverse" : "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Animated.View style={{ marginTop: AAnimation }}>
        <A />
      </Animated.View>
      <Animated.View style={{ marginTop: SAnimation }}>
        <S />
      </Animated.View>
      <Animated.View style={{ marginTop: QAnimation }}>
        <Q />
      </Animated.View>

      <Animated.View
        style={{
          marginLeft: Platform.OS === "android" && main.rtl ? 0 : -50,
          marginRight: Platform.OS === "android" && main.rtl ? -50 : 0,
          marginTop: ASQPENAnimation,
        }}
      >
        <ASQPEN />
      </Animated.View>
    </View>
  );
}
